module.exports = __webpack_public_path__ + "img/personal-roboport-equipment.e42db462.png";